var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiCharacterIcon = function SvgAiCharacterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai-character-icon_svg__a)",
    d: "M11 20c6.075 0 11 4.925 11 11v7a2 2 0 1 1-4 0v-7a7 7 0 1 0-14 0v7a2 2 0 1 1-4 0v-7c0-6.075 4.925-11 11-11m0-18a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#748499",
    fillRule: "evenodd",
    d: "M29 20c6.075 0 11 4.925 11 11v7a2 2 0 0 1-4 0v-7a7 7 0 0 0-10.888-5.822 2 2 0 0 1-2.224-3.325A10.96 10.96 0 0 1 29 20m0-18a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-character-icon_svg__a",
    x1: 0,
    x2: 32.852,
    y1: 40,
    y2: 23.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AC0"
  })))));
};
export { SvgAiCharacterIcon as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-character-icon-3cf9e5b8107c4b1fca3d3bae5328c639.svg";